export default __webpack_public_path__ + "static/media/05.09846529.jpg";